import classNames from 'classnames';
import { SupportIcon } from '../../../icons';
import { Link } from '../../navigation';
import { Text } from '../../typography';
import { IsVisible } from '../../utils';

interface ISupportHandlingProps {
  claimId?: string | undefined;
  iconColor?: string | undefined;
  interventionId?: string | undefined;
  text?: string | undefined;
  textColor?: string | undefined;
  traderId?: string | undefined;
}

export function SupportButton({
  claimId,
  iconColor,
  interventionId,
  text,
  textColor,
  traderId,
}: ISupportHandlingProps) {
  const handleSupportClick = () => {
    const queryParams = new URLSearchParams();
    if (claimId) {
      queryParams.set('customfield_10074', claimId.toString());
    }
    if (traderId) {
      queryParams.set('customfield_10072', traderId.toString());
    }
    if (interventionId) {
      // @todo check support link
      queryParams.set('customfield_10072', interventionId.toString());
    }
    const url = `https://fixxer-eu.atlassian.net/servicedesk/customer/portal/1/group/8/create/21?${queryParams.toString()}`;
    return url;
  };
  return (
    <Link
      className={classNames('relative text-gray-700 px-1 h-10 w-10', {
        'flex flex-col items-center justify-center h-18 w-fit': !!text,
      })}
      design="transparent"
      hoverVariant="opacity"
      href={handleSupportClick()}
      rel="noopener noreferrer"
      target="_blank"
    >
      <SupportIcon color={iconColor || '#9F0336'} />
      <IsVisible when={!!text}>
        <Text
          className={`text-sm font-semibold w-full	text-center ${
            textColor ? `text-${textColor}` : 'text-white'
          }`}
        >
          {text}
        </Text>
      </IsVisible>
    </Link>
  );
}
